import { ColorInput } from '../../../baseInputs/colorInput/ColorInput';

export const BackgroundInput = ({
  value,
  onChange,
  onlySolid = false,
}: {
  value?: string;
  onChange: (newValue?: string) => void;
  onlySolid?: boolean;
}) => {
  return <ColorInput value={value} onChange={onChange} onlySolid={onlySolid} />;
};
